import { Link } from "react-router-dom";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { FiArrowLeft } from "react-icons/fi";

const NotFound = () => {
  useDocumentTitle("Page Not Found");
  return (
    <div className="flex flex-col items-center justify-center px-6 py-24 text-light-text dark:text-text-primary md:py-32">
      <p className="mb-2 font-mono text-sm uppercase tracking-[0.2em] text-light-muted dark:text-text-faint">
        Error
      </p>
      <p className="mb-4 text-8xl font-bold text-accent/30">
        404
      </p>
      <h1 className="mb-4 text-2xl font-bold tracking-tight">
        Page not found
      </h1>
      <p className="mb-8 max-w-md text-center text-light-muted dark:text-text-muted leading-relaxed">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <Link
        to="/"
        className="group inline-flex items-center gap-2 rounded-lg bg-light-text dark:bg-text-primary px-6 py-3 font-semibold text-sm text-light-surface dark:text-surface-0 transition hover:bg-light-text-secondary dark:hover:bg-text-secondary"
      >
        <FiArrowLeft size={14} />
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;
